(function () {
  'use strict';
  var source = document.getElementById('fb-ro-clearance-config');
  if (!source) return;
  var config;
  try { config = JSON.parse(source.textContent); } catch (error) { return; }
  var start = Date.parse(config.start), end = Date.parse(config.end);
  var valid = Boolean(config.enabled) && Number.isFinite(start) && Number.isFinite(end) && end > start;
  var timer;
  var deadline = Number.isFinite(end) ? new Intl.DateTimeFormat('ro-RO', {timeZone:'Europe/Bucharest', day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit', hour12:false}).format(new Date(end)) : '';
  function tick() {
    var now = Date.now();
    // Promotional benefits remain disabled after the campaign clock expires.
    document.documentElement.classList.toggle('fb-ro-clearance-active', Boolean(config.enabled));
    var visible = valid && now >= start && end > now;
    var seconds = Math.max(0, Math.ceil((end - now) / 1000));
    var values = {days:Math.floor(seconds / 86400), hours:Math.floor(seconds / 3600) % 24, minutes:Math.floor(seconds / 60) % 60, seconds:seconds % 60};
    document.querySelectorAll('[data-fb-ro-clock]').forEach(function (clock) {
      clock.hidden = !visible;
      var wrapper = clock.closest('.fb-ro-campaign-clock-wrap, .fb-ro-editorial-clock-wrap, .fb-ro-cart-clock-wrap');
      if (wrapper) wrapper.hidden = !visible;
      if (!visible) return;
      Object.keys(values).forEach(function (unit) {
        var field = clock.querySelector('[data-unit="' + unit + '"]');
        var value = String(values[unit]).padStart(2, '0');
        if (field && field.textContent !== value) field.textContent = value;
      });
      var label = clock.querySelector('[data-fb-ro-deadline]');
      if (label && label.textContent !== deadline) label.textContent = deadline;
    });
    if (!valid || now >= end) { clearInterval(timer); timer = null; }
  }
  function refresh() {
    tick();
    if (valid && end > Date.now() && !timer) timer = setInterval(tick, 1000);
  }
  refresh();
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('visibilitychange', refresh);
  window.addEventListener('pageshow', refresh);
  new MutationObserver(function (records) {
    if (records.some(function (record) { return Array.from(record.addedNodes).some(function (node) { return node.nodeType === 1; }); })) refresh();
  }).observe(document.body, {childList:true, subtree:true});
})();
